import { t } from "i18next";

import styles from "./Modal.module.scss";
import { Button, Icon } from "@livingmap/hippo";

interface Props {
  closeModal: () => void;
  onCloseSidebar: () => void;
}

const CloseSidebar: React.FC<Props> = ({ closeModal, onCloseSidebar }) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h5 className={styles.title}>{t("modals.exit_without_save.title")}</h5>
        <button className={styles.closeButton} onClick={closeModal}>
          <Icon dataQA="close-icon" name="close" size={24} />
        </button>
      </div>
      <div className={styles.contentContainer}>
        <p className={styles.description}>
          {t("modals.exit_without_save.description")}
        </p>
        <div className={styles.buttonWrapper}>
          <Button
            dataQA="keep-editing-button"
            type="primary"
            size="regular"
            style="filled"
            text={t("btn_labels.keep_editing")}
            onClick={closeModal}
          />
          <Button
            dataQA="exit-button"
            type="location"
            size="regular"
            style="filled"
            text={t("btn_labels.exit")}
            onClick={onCloseSidebar}
          />
        </div>
      </div>
    </div>
  );
};

export default CloseSidebar;
